import { useLang } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="overflow-hidden border-y border-black/5 bg-white py-4" data-testid="marquee">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap pr-10">
        {items.map((s, i) => (
          <span key={i} className="font-display flex items-center gap-10 text-sm font-semibold uppercase tracking-[0.16em] text-[var(--ink-2)]">
            {s}<span className="h-1.5 w-1.5 rounded-full bg-[var(--coral)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
